import { NextPage } from "next"
import { useState } from "react"
import { getExtension } from '../util'
import { GrDocumentPdf } from 'react-icons/gr'
import { RiImage2Line, RiFileHwpLine, RiFileWord2Line, RiFileExcel2Line, RiFilePpt2Line, RiFile2Line, RiFileZipLine } from 'react-icons/ri'

interface IProps {
  filename: string;
  width?: number;
  height?: number;
}

const Component: NextPage<IProps> = ({ filename, width, height }) => {
  const [wrapWidth, setWrapWidth] = useState<number>(width || 24);
  const [wrapHeight, setWrapHeight] = useState<number>(height || 24);
  // const setWidth = width || 24;
  // const setHeight = height || 24;
  // "jpg" | "jpeg" | "png" | "gif" | "pdf" | "doc" | "docx" | "xls" | "xlsx" | "ppt" | "pptx" | "hwp"
  let icon: JSX.Element;
  switch(getExtension(filename)) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif': icon = <RiImage2Line className="w-full h-full" />; break;
    case 'pdf': icon = <GrDocumentPdf className="w-full h-full" />; break;
    case 'doc': icon = <RiFileWord2Line className="w-full h-full" />; break;
    case 'docx': icon = <RiFileWord2Line className="w-full h-full" />; break;
    case 'xls': icon = <RiFileExcel2Line className="w-full h-full" />; break;
    case 'xlsx': icon = <RiFileExcel2Line className="w-full h-full" />; break;
    case 'ppt': icon = <RiFilePpt2Line className="w-full h-full" />; break;
    case 'pptx': icon = <RiFilePpt2Line className="w-full h-full" />; break;
    case 'hwp': icon = <RiFileHwpLine className="w-full h-full" />; break;
    case 'zip': icon = <RiFileZipLine className="w-full h-full" />; break;
    default: icon = <RiFile2Line className="w-full h-full" />; break;
  }
  return (
    <div style={{width: `${wrapWidth}px`, height: `${wrapHeight}px`}}>
      {icon}
    </div>
  )
}

export default Component;
